import { render } from "./SmallAddButtonRed.vue?vue&type=template&id=472be37f&scoped=true"
import script from "./SmallAddButtonRed.vue?vue&type=script&lang=js"
export * from "./SmallAddButtonRed.vue?vue&type=script&lang=js"

import "./SmallAddButtonRed.vue?vue&type=style&index=0&id=472be37f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472be37f"]])

export default __exports__